module.exports = __webpack_public_path__ + "static/media/occ-therapy.9e0508ee.jpg";